import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button14Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M6.63604 19.3639C10.1508 22.8787 15.8492 22.8787 19.364 19.3639C22.8787 15.8492 22.8787 10.1507 19.364 6.63603C15.8492 3.12131 10.1508 3.12131 6.63604 6.63603C3.12132 10.1507 3.12132 15.8492 6.63604 19.3639ZM13 11.2322L16.3588 7.87346L18.1265 9.64123L14.7678 13L18.1265 16.3587L16.3588 18.1265L13 14.7678L9.64124 18.1265L7.87348 16.3587L11.2322 13L7.87348 9.64123L9.64124 7.87346L13 11.2322Z" />
  </SvgIcon>
);

export default PO28Button14Icon;
